import { LANGS, useLangStore } from '../i18n';

/**
 * 🇨🇿 CZ | 🇬🇧 EN switcher — persists the choice in localStorage and re-renders every
 * localized component (the language lives in a zustand store, not in props).
 */
export const LangSwitcher = () => {
  const lang = useLangStore((state) => state.lang);
  const setLang = useLangStore((state) => state.setLang);
  return (
    <div
      role="group"
      aria-label="Language / Jazyk"
      className="flex shrink-0 items-center gap-0.5 rounded-lg border border-slate-700/70 bg-slate-900/80 p-0.5"
    >
      {LANGS.map((entry) => {
        const activeLang = lang === entry.id;
        return (
          <button
            key={entry.id}
            type="button"
            onClick={() => setLang(entry.id)}
            title={entry.title}
            aria-pressed={activeLang}
            className={`min-h-[28px] rounded-md px-2 text-[11px] font-black transition ${
              activeLang ? 'bg-amber-500/30 text-amber-100' : 'text-slate-400 hover:bg-slate-800 hover:text-slate-200'
            }`}
          >
            <span aria-hidden>{entry.flag}</span> {entry.label}
          </button>
        );
      })}
    </div>
  );
};

export default LangSwitcher;
